export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png'];

export const TEXT_EXTENSIONS = ['doc', 'docx', 'txt', 'odt'];

export const OTHER_EXTENSIONS = [
  'pdf',
  'pptx',
  'xlsx',
  'xlsm',
  'zip',
  'xlsb',
  'mpp',
  'mp4',
  'msg',
  'ods',
  'cpg',
  'shp',
  'dbf',
  'prj',
  'qpj',
  'shx',
  'kmz',
  'csv',
  'qgz',
  'xls',
  'qml',
  'qgs',
  'bak',
  'sbn',
  'sbx',
  'xml',
  'tbx',
  'vsdx',
  '7z',
  'vsdm',
  'rtf',
  'CC',
  'sor',
  'oltsx',
  'xer',
  'eml',
  'erp',
  'plf',
];
